import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/practitioners/$practitionerId')({
  component: Outlet,
  loader: () => ({ crumb: 'Practitioner' }),
});
